import { StopEntry } from "../StopEntry";
import { YSplitStopsTable } from "../YSplitStopsTable";
import { DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutYSplit extends Layout {
    horizontalspacer1: HorizontalSpacer;
    labelExplanationOne: Label;
    labelMovementType: Label;
    labelStops: Label;
    layoutStopEntry: StopEntry;
    layoutYSplitStopsTable: YSplitStopsTable;
    panelNewMovementType: Panel;
    panelStopEntry: Panel;
    panelYSplitStopTable: Panel;
    sourceStop: DataSource;
    switchBrokerageSplit: Switch;
    tabCreateYSplit: Tab;
    tabsetYSplit: Tabset;
}
